<div class="container">
    <!--Checking the presence of items-->
    <div *ngIf="items" class="row">
        <div class="col-6">
            <div class="heading">
                <h1>Items</h1>
                <h5>All available items</h5>
                <div class="d-flex mt-4">
                    <!--Filtering the items by the field (name)-->
                    <input (keyup)="filter('name', $event.target.value)" type="text" class="form-control w-50 mr-3" placeholder="Search by name">
                    <select (change)="filter('type', $event.target.value)" class="form-control w-50" name="type" placeholder="Search by type">
                        <option selected></option>
                        <option *ngFor="let type of itemService.types" [value]="type">{{type}}</option>
                    </select>
                </div>
            </div>
            <!--List of items-->
            <item-list [items]="filteredItems" (delete)="delete($event)" (edit)="edit($event)"></item-list>
        </div>
        <div class="col-6">
            <div class="heading">
                <h1>Creator</h1>
                <h5>Create new item</h5>
            </div>
            <!--Item form form adding/updating a selected item-->
            <item-form></item-form>
        </div>
    </div>
</div>
